import { render, staticRenderFns } from "./history-entry.vue?vue&type=template&id=674f7644&scoped=true&"
import script from "./history-entry.vue?vue&type=script&lang=js&"
export * from "./history-entry.vue?vue&type=script&lang=js&"
import style0 from "./history-entry.vue?vue&type=style&index=0&id=674f7644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f7644",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/magonxesp/repos/RandomAnimePicker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('674f7644')) {
      api.createRecord('674f7644', component.options)
    } else {
      api.reload('674f7644', component.options)
    }
    module.hot.accept("./history-entry.vue?vue&type=template&id=674f7644&scoped=true&", function () {
      api.rerender('674f7644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/history/history-entry.vue"
export default component.exports